var map = {
	"./de_DE.json": 682,
	"./en_AU.json": 683,
	"./en_CA.json": 684,
	"./en_GB.json": 685,
	"./es_AR.json": 686,
	"./es_ES.json": 687,
	"./es_MX.json": 688,
	"./fr_CA.json": 689,
	"./fr_FR.json": 690,
	"./it_IT.json": 691,
	"./nl_NL.json": 692,
	"./pt_BR.json": 693,
	"./pt_PT.json": 694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;